/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * rain/v1/artifact_catalog_service.proto
 * OpenAPI spec version: version not set
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import * as axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

import type {
  ArtifactCatalogServiceCreateArtifactStoreBody,
  ArtifactCatalogServiceGetDynamicArtifactStoreConfigSchemaBody,
  ArtifactCatalogServiceListArtifactStoreDynamicEnumValuesBody,
  ArtifactCatalogServiceUpdateArtifactStoreBody,
  ArtifactCatalogServiceValidateArtifactStoreConfigSchemaBody,
  RpcStatus,
  V1ArtifactStore,
  V1DiffArtifactStoresResponse,
  V1DynamicEnumValuesResponse,
  V1GetConfigSchemaResponse,
  V1ListArtifactStoreKindsResponse,
  V1ListArtifactStoresResponse,
  V1ValidateConfigResponse,
  WorkspaceDeleteArtifactStore200,
  WorkspaceDeleteArtifactStoreParams,
  WorkspaceDiffArtifactStoresParams,
  WorkspaceGetStaticArtifactStoreConfigSchemaParams,
  WorkspaceListArtifactStoresParams,
} from '../../models';

/**
 * @summary Dynamic (layer-2) config schema for a artifact_store kind, derived from its static values.
 */
export const workspaceGetDynamicArtifactStoreConfigSchema = (
  organization: string,
  workspace: string,
  agentId: string,
  artifactCatalogServiceGetDynamicArtifactStoreConfigSchemaBody: ArtifactCatalogServiceGetDynamicArtifactStoreConfigSchemaBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GetConfigSchemaResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/artifact-stores:dynamic-config`,
    artifactCatalogServiceGetDynamicArtifactStoreConfigSchemaBody,
    options,
  );
};

export const getWorkspaceGetDynamicArtifactStoreConfigSchemaMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceGetDynamicArtifactStoreConfigSchema>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      data: ArtifactCatalogServiceGetDynamicArtifactStoreConfigSchemaBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceGetDynamicArtifactStoreConfigSchema>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    data: ArtifactCatalogServiceGetDynamicArtifactStoreConfigSchemaBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceGetDynamicArtifactStoreConfigSchema'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceGetDynamicArtifactStoreConfigSchema>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      data: ArtifactCatalogServiceGetDynamicArtifactStoreConfigSchemaBody;
    }
  > = props => {
    const { organization, workspace, agentId, data } = props ?? {};

    return workspaceGetDynamicArtifactStoreConfigSchema(
      organization,
      workspace,
      agentId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceGetDynamicArtifactStoreConfigSchemaMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof workspaceGetDynamicArtifactStoreConfigSchema>>
  >;
export type WorkspaceGetDynamicArtifactStoreConfigSchemaMutationBody =
  ArtifactCatalogServiceGetDynamicArtifactStoreConfigSchemaBody;
export type WorkspaceGetDynamicArtifactStoreConfigSchemaMutationError =
  AxiosError<RpcStatus>;

/**
 * @summary Dynamic (layer-2) config schema for a artifact_store kind, derived from its static values.
 */
export const useWorkspaceGetDynamicArtifactStoreConfigSchema = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceGetDynamicArtifactStoreConfigSchema>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        data: ArtifactCatalogServiceGetDynamicArtifactStoreConfigSchemaBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceGetDynamicArtifactStoreConfigSchema>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    data: ArtifactCatalogServiceGetDynamicArtifactStoreConfigSchemaBody;
  },
  TContext
> => {
  const mutationOptions =
    getWorkspaceGetDynamicArtifactStoreConfigSchemaMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Re-resolves the dynamic option list for one artifact store config field.
 */
export const workspaceListArtifactStoreDynamicEnumValues = (
  organization: string,
  workspace: string,
  agentId: string,
  artifactCatalogServiceListArtifactStoreDynamicEnumValuesBody: ArtifactCatalogServiceListArtifactStoreDynamicEnumValuesBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1DynamicEnumValuesResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/artifact-stores:dynamic-enum-values`,
    artifactCatalogServiceListArtifactStoreDynamicEnumValuesBody,
    options,
  );
};

export const getWorkspaceListArtifactStoreDynamicEnumValuesMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceListArtifactStoreDynamicEnumValues>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      data: ArtifactCatalogServiceListArtifactStoreDynamicEnumValuesBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceListArtifactStoreDynamicEnumValues>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    data: ArtifactCatalogServiceListArtifactStoreDynamicEnumValuesBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceListArtifactStoreDynamicEnumValues'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceListArtifactStoreDynamicEnumValues>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      data: ArtifactCatalogServiceListArtifactStoreDynamicEnumValuesBody;
    }
  > = props => {
    const { organization, workspace, agentId, data } = props ?? {};

    return workspaceListArtifactStoreDynamicEnumValues(
      organization,
      workspace,
      agentId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceListArtifactStoreDynamicEnumValuesMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof workspaceListArtifactStoreDynamicEnumValues>>
  >;
export type WorkspaceListArtifactStoreDynamicEnumValuesMutationBody =
  ArtifactCatalogServiceListArtifactStoreDynamicEnumValuesBody;
export type WorkspaceListArtifactStoreDynamicEnumValuesMutationError =
  AxiosError<RpcStatus>;

/**
 * @summary Re-resolves the dynamic option list for one artifact store config field.
 */
export const useWorkspaceListArtifactStoreDynamicEnumValues = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceListArtifactStoreDynamicEnumValues>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        data: ArtifactCatalogServiceListArtifactStoreDynamicEnumValuesBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceListArtifactStoreDynamicEnumValues>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    data: ArtifactCatalogServiceListArtifactStoreDynamicEnumValuesBody;
  },
  TContext
> => {
  const mutationOptions =
    getWorkspaceListArtifactStoreDynamicEnumValuesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Static (layer-1) config schema for a artifact_store kind.
 */
export const workspaceGetStaticArtifactStoreConfigSchema = (
  organization: string,
  workspace: string,
  agentId: string,
  params: WorkspaceGetStaticArtifactStoreConfigSchemaParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GetConfigSchemaResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/artifact-stores:static-config`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceGetStaticArtifactStoreConfigSchemaQueryKey = (
  organization?: string,
  workspace?: string,
  agentId?: string,
  params?: WorkspaceGetStaticArtifactStoreConfigSchemaParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/artifact-stores:static-config`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceGetStaticArtifactStoreConfigSchemaQueryOptions = <
  TData = Awaited<
    ReturnType<typeof workspaceGetStaticArtifactStoreConfigSchema>
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  params: WorkspaceGetStaticArtifactStoreConfigSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetStaticArtifactStoreConfigSchema>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceGetStaticArtifactStoreConfigSchemaQueryKey(
      organization,
      workspace,
      agentId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceGetStaticArtifactStoreConfigSchema>>
  > = ({ signal }) =>
    workspaceGetStaticArtifactStoreConfigSchema(
      organization,
      workspace,
      agentId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && agentId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceGetStaticArtifactStoreConfigSchema>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceGetStaticArtifactStoreConfigSchemaQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof workspaceGetStaticArtifactStoreConfigSchema>>
  >;
export type WorkspaceGetStaticArtifactStoreConfigSchemaQueryError =
  AxiosError<RpcStatus>;

export function useWorkspaceGetStaticArtifactStoreConfigSchema<
  TData = Awaited<
    ReturnType<typeof workspaceGetStaticArtifactStoreConfigSchema>
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  params: WorkspaceGetStaticArtifactStoreConfigSchemaParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetStaticArtifactStoreConfigSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof workspaceGetStaticArtifactStoreConfigSchema>
          >,
          TError,
          Awaited<
            ReturnType<typeof workspaceGetStaticArtifactStoreConfigSchema>
          >
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetStaticArtifactStoreConfigSchema<
  TData = Awaited<
    ReturnType<typeof workspaceGetStaticArtifactStoreConfigSchema>
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  params: WorkspaceGetStaticArtifactStoreConfigSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetStaticArtifactStoreConfigSchema>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof workspaceGetStaticArtifactStoreConfigSchema>
          >,
          TError,
          Awaited<
            ReturnType<typeof workspaceGetStaticArtifactStoreConfigSchema>
          >
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceGetStaticArtifactStoreConfigSchema<
  TData = Awaited<
    ReturnType<typeof workspaceGetStaticArtifactStoreConfigSchema>
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  params: WorkspaceGetStaticArtifactStoreConfigSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetStaticArtifactStoreConfigSchema>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Static (layer-1) config schema for a artifact_store kind.
 */

export function useWorkspaceGetStaticArtifactStoreConfigSchema<
  TData = Awaited<
    ReturnType<typeof workspaceGetStaticArtifactStoreConfigSchema>
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  params: WorkspaceGetStaticArtifactStoreConfigSchemaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceGetStaticArtifactStoreConfigSchema>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getWorkspaceGetStaticArtifactStoreConfigSchemaQueryOptions(
      organization,
      workspace,
      agentId,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary ============================================================================
Validation
============================================================================
Validates an artifact store's configuration without saving.
 */
export const workspaceValidateArtifactStoreConfigSchema = (
  organization: string,
  workspace: string,
  agentId: string,
  artifactCatalogServiceValidateArtifactStoreConfigSchemaBody: ArtifactCatalogServiceValidateArtifactStoreConfigSchemaBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ValidateConfigResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/artifact-stores:validate`,
    artifactCatalogServiceValidateArtifactStoreConfigSchemaBody,
    options,
  );
};

export const getWorkspaceValidateArtifactStoreConfigSchemaMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceValidateArtifactStoreConfigSchema>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      data: ArtifactCatalogServiceValidateArtifactStoreConfigSchemaBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceValidateArtifactStoreConfigSchema>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    data: ArtifactCatalogServiceValidateArtifactStoreConfigSchemaBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceValidateArtifactStoreConfigSchema'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceValidateArtifactStoreConfigSchema>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      data: ArtifactCatalogServiceValidateArtifactStoreConfigSchemaBody;
    }
  > = props => {
    const { organization, workspace, agentId, data } = props ?? {};

    return workspaceValidateArtifactStoreConfigSchema(
      organization,
      workspace,
      agentId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceValidateArtifactStoreConfigSchemaMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof workspaceValidateArtifactStoreConfigSchema>>
  >;
export type WorkspaceValidateArtifactStoreConfigSchemaMutationBody =
  ArtifactCatalogServiceValidateArtifactStoreConfigSchemaBody;
export type WorkspaceValidateArtifactStoreConfigSchemaMutationError =
  AxiosError<RpcStatus>;

/**
 * @summary ============================================================================
Validation
============================================================================
Validates an artifact store's configuration without saving.
 */
export const useWorkspaceValidateArtifactStoreConfigSchema = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceValidateArtifactStoreConfigSchema>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        data: ArtifactCatalogServiceValidateArtifactStoreConfigSchemaBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceValidateArtifactStoreConfigSchema>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    data: ArtifactCatalogServiceValidateArtifactStoreConfigSchemaBody;
  },
  TContext
> => {
  const mutationOptions =
    getWorkspaceValidateArtifactStoreConfigSchemaMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary ============================================================================
Store Management (thread-scoped)
============================================================================
Lists the artifact stores for a thread.
 */
export const workspaceListArtifactStores = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceListArtifactStoresParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListArtifactStoresResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/artifact-stores`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceListArtifactStoresQueryKey = (
  organization?: string,
  workspace?: string,
  agentId?: string,
  threadId?: string,
  params?: WorkspaceListArtifactStoresParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/artifact-stores`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceListArtifactStoresQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceListArtifactStores>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceListArtifactStoresParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListArtifactStores>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceListArtifactStoresQueryKey(
      organization,
      workspace,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceListArtifactStores>>
  > = ({ signal }) =>
    workspaceListArtifactStores(
      organization,
      workspace,
      agentId,
      threadId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && agentId && threadId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceListArtifactStores>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceListArtifactStoresQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceListArtifactStores>>
>;
export type WorkspaceListArtifactStoresQueryError = AxiosError<RpcStatus>;

export function useWorkspaceListArtifactStores<
  TData = Awaited<ReturnType<typeof workspaceListArtifactStores>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params: undefined | WorkspaceListArtifactStoresParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListArtifactStores>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceListArtifactStores>>,
          TError,
          Awaited<ReturnType<typeof workspaceListArtifactStores>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceListArtifactStores<
  TData = Awaited<ReturnType<typeof workspaceListArtifactStores>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceListArtifactStoresParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListArtifactStores>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceListArtifactStores>>,
          TError,
          Awaited<ReturnType<typeof workspaceListArtifactStores>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceListArtifactStores<
  TData = Awaited<ReturnType<typeof workspaceListArtifactStores>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceListArtifactStoresParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListArtifactStores>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary ============================================================================
Store Management (thread-scoped)
============================================================================
Lists the artifact stores for a thread.
 */

export function useWorkspaceListArtifactStores<
  TData = Awaited<ReturnType<typeof workspaceListArtifactStores>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceListArtifactStoresParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListArtifactStores>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceListArtifactStoresQueryOptions(
    organization,
    workspace,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Creates a new artifact store for a thread.
 */
export const workspaceCreateArtifactStore = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  artifactCatalogServiceCreateArtifactStoreBody: ArtifactCatalogServiceCreateArtifactStoreBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ArtifactStore>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/artifact-stores`,
    artifactCatalogServiceCreateArtifactStoreBody,
    options,
  );
};

export const getWorkspaceCreateArtifactStoreMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceCreateArtifactStore>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ArtifactCatalogServiceCreateArtifactStoreBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceCreateArtifactStore>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ArtifactCatalogServiceCreateArtifactStoreBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceCreateArtifactStore'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceCreateArtifactStore>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      data: ArtifactCatalogServiceCreateArtifactStoreBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, data } = props ?? {};

    return workspaceCreateArtifactStore(
      organization,
      workspace,
      agentId,
      threadId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceCreateArtifactStoreMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceCreateArtifactStore>>
>;
export type WorkspaceCreateArtifactStoreMutationBody =
  ArtifactCatalogServiceCreateArtifactStoreBody;
export type WorkspaceCreateArtifactStoreMutationError = AxiosError<RpcStatus>;

/**
 * @summary Creates a new artifact store for a thread.
 */
export const useWorkspaceCreateArtifactStore = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceCreateArtifactStore>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        data: ArtifactCatalogServiceCreateArtifactStoreBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceCreateArtifactStore>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    data: ArtifactCatalogServiceCreateArtifactStoreBody;
  },
  TContext
> => {
  const mutationOptions =
    getWorkspaceCreateArtifactStoreMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Deletes an artifact store from a thread.
 */
export const workspaceDeleteArtifactStore = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  storeId: string,
  params?: WorkspaceDeleteArtifactStoreParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<WorkspaceDeleteArtifactStore200>> => {
  return axios.default.delete(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/artifact-stores/${storeId}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceDeleteArtifactStoreMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceDeleteArtifactStore>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      storeId: string;
      params?: WorkspaceDeleteArtifactStoreParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceDeleteArtifactStore>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    storeId: string;
    params?: WorkspaceDeleteArtifactStoreParams;
  },
  TContext
> => {
  const mutationKey = ['workspaceDeleteArtifactStore'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceDeleteArtifactStore>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      storeId: string;
      params?: WorkspaceDeleteArtifactStoreParams;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, storeId, params } =
      props ?? {};

    return workspaceDeleteArtifactStore(
      organization,
      workspace,
      agentId,
      threadId,
      storeId,
      params,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceDeleteArtifactStoreMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceDeleteArtifactStore>>
>;

export type WorkspaceDeleteArtifactStoreMutationError = AxiosError<RpcStatus>;

/**
 * @summary Deletes an artifact store from a thread.
 */
export const useWorkspaceDeleteArtifactStore = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceDeleteArtifactStore>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        storeId: string;
        params?: WorkspaceDeleteArtifactStoreParams;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceDeleteArtifactStore>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    storeId: string;
    params?: WorkspaceDeleteArtifactStoreParams;
  },
  TContext
> => {
  const mutationOptions =
    getWorkspaceDeleteArtifactStoreMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Updates an artifact store configuration on a thread.
 */
export const workspaceUpdateArtifactStore = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  storeId: string,
  artifactCatalogServiceUpdateArtifactStoreBody: ArtifactCatalogServiceUpdateArtifactStoreBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ArtifactStore>> => {
  return axios.default.patch(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/artifact-stores/${storeId}`,
    artifactCatalogServiceUpdateArtifactStoreBody,
    options,
  );
};

export const getWorkspaceUpdateArtifactStoreMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workspaceUpdateArtifactStore>>,
    TError,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      storeId: string;
      data: ArtifactCatalogServiceUpdateArtifactStoreBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workspaceUpdateArtifactStore>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    storeId: string;
    data: ArtifactCatalogServiceUpdateArtifactStoreBody;
  },
  TContext
> => {
  const mutationKey = ['workspaceUpdateArtifactStore'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workspaceUpdateArtifactStore>>,
    {
      organization: string;
      workspace: string;
      agentId: string;
      threadId: string;
      storeId: string;
      data: ArtifactCatalogServiceUpdateArtifactStoreBody;
    }
  > = props => {
    const { organization, workspace, agentId, threadId, storeId, data } =
      props ?? {};

    return workspaceUpdateArtifactStore(
      organization,
      workspace,
      agentId,
      threadId,
      storeId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkspaceUpdateArtifactStoreMutationResult = NonNullable<
  Awaited<ReturnType<typeof workspaceUpdateArtifactStore>>
>;
export type WorkspaceUpdateArtifactStoreMutationBody =
  ArtifactCatalogServiceUpdateArtifactStoreBody;
export type WorkspaceUpdateArtifactStoreMutationError = AxiosError<RpcStatus>;

/**
 * @summary Updates an artifact store configuration on a thread.
 */
export const useWorkspaceUpdateArtifactStore = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof workspaceUpdateArtifactStore>>,
      TError,
      {
        organization: string;
        workspace: string;
        agentId: string;
        threadId: string;
        storeId: string;
        data: ArtifactCatalogServiceUpdateArtifactStoreBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof workspaceUpdateArtifactStore>>,
  TError,
  {
    organization: string;
    workspace: string;
    agentId: string;
    threadId: string;
    storeId: string;
    data: ArtifactCatalogServiceUpdateArtifactStoreBody;
  },
  TContext
> => {
  const mutationOptions =
    getWorkspaceUpdateArtifactStoreMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Returns the thread's effective artifact stores and the pinned
agent version's stores side-by-side so callers can render a diff.
 */
export const workspaceDiffArtifactStores = (
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceDiffArtifactStoresParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1DiffArtifactStoresResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/artifact-stores:diff`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getWorkspaceDiffArtifactStoresQueryKey = (
  organization?: string,
  workspace?: string,
  agentId?: string,
  threadId?: string,
  params?: WorkspaceDiffArtifactStoresParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/agents/${agentId}/threads/${threadId}/artifact-stores:diff`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWorkspaceDiffArtifactStoresQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceDiffArtifactStores>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceDiffArtifactStoresParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceDiffArtifactStores>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceDiffArtifactStoresQueryKey(
      organization,
      workspace,
      agentId,
      threadId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceDiffArtifactStores>>
  > = ({ signal }) =>
    workspaceDiffArtifactStores(
      organization,
      workspace,
      agentId,
      threadId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && agentId && threadId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceDiffArtifactStores>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceDiffArtifactStoresQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceDiffArtifactStores>>
>;
export type WorkspaceDiffArtifactStoresQueryError = AxiosError<RpcStatus>;

export function useWorkspaceDiffArtifactStores<
  TData = Awaited<ReturnType<typeof workspaceDiffArtifactStores>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params: undefined | WorkspaceDiffArtifactStoresParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceDiffArtifactStores>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceDiffArtifactStores>>,
          TError,
          Awaited<ReturnType<typeof workspaceDiffArtifactStores>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceDiffArtifactStores<
  TData = Awaited<ReturnType<typeof workspaceDiffArtifactStores>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceDiffArtifactStoresParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceDiffArtifactStores>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceDiffArtifactStores>>,
          TError,
          Awaited<ReturnType<typeof workspaceDiffArtifactStores>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceDiffArtifactStores<
  TData = Awaited<ReturnType<typeof workspaceDiffArtifactStores>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceDiffArtifactStoresParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceDiffArtifactStores>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Returns the thread's effective artifact stores and the pinned
agent version's stores side-by-side so callers can render a diff.
 */

export function useWorkspaceDiffArtifactStores<
  TData = Awaited<ReturnType<typeof workspaceDiffArtifactStores>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  agentId: string,
  threadId: string,
  params?: WorkspaceDiffArtifactStoresParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceDiffArtifactStores>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceDiffArtifactStoresQueryOptions(
    organization,
    workspace,
    agentId,
    threadId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Lists available artifact store kinds and their configuration schemas.
 */
export const workspaceListArtifactStoreKinds = (
  organization: string,
  workspace: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListArtifactStoreKindsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/artifact-stores/kinds`,
    options,
  );
};

export const getWorkspaceListArtifactStoreKindsQueryKey = (
  organization?: string,
  workspace?: string,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/artifact-stores/kinds`,
  ] as const;
};

export const getWorkspaceListArtifactStoreKindsQueryOptions = <
  TData = Awaited<ReturnType<typeof workspaceListArtifactStoreKinds>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListArtifactStoreKinds>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getWorkspaceListArtifactStoreKindsQueryKey(organization, workspace);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof workspaceListArtifactStoreKinds>>
  > = ({ signal }) =>
    workspaceListArtifactStoreKinds(organization, workspace, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof workspaceListArtifactStoreKinds>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WorkspaceListArtifactStoreKindsQueryResult = NonNullable<
  Awaited<ReturnType<typeof workspaceListArtifactStoreKinds>>
>;
export type WorkspaceListArtifactStoreKindsQueryError = AxiosError<RpcStatus>;

export function useWorkspaceListArtifactStoreKinds<
  TData = Awaited<ReturnType<typeof workspaceListArtifactStoreKinds>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListArtifactStoreKinds>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceListArtifactStoreKinds>>,
          TError,
          Awaited<ReturnType<typeof workspaceListArtifactStoreKinds>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceListArtifactStoreKinds<
  TData = Awaited<ReturnType<typeof workspaceListArtifactStoreKinds>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListArtifactStoreKinds>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceListArtifactStoreKinds>>,
          TError,
          Awaited<ReturnType<typeof workspaceListArtifactStoreKinds>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useWorkspaceListArtifactStoreKinds<
  TData = Awaited<ReturnType<typeof workspaceListArtifactStoreKinds>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListArtifactStoreKinds>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists available artifact store kinds and their configuration schemas.
 */

export function useWorkspaceListArtifactStoreKinds<
  TData = Awaited<ReturnType<typeof workspaceListArtifactStoreKinds>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof workspaceListArtifactStoreKinds>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getWorkspaceListArtifactStoreKindsQueryOptions(
    organization,
    workspace,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
